import React, { ReactNode } from 'react';
import { Columns, Column } from 'bloomer';

export function CenteredForm({
  children,
  onSubmit
}: {
  children: ReactNode;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}) {
  return (
    <form onSubmit={onSubmit}>
      <Columns isCentered isVCentered>
        <Column isSize="1/3"></Column>
        <Column isSize="1/3">{children}</Column>
        <Column isSize="1/3"></Column>
      </Columns>
    </form>
  );
}
